import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "content"]
  static values = { collapsed: Boolean }

  connect() {
    // Immediately set the correct state to prevent flash
    const savedState = localStorage.getItem('sidebarCollapsed')
    if (savedState !== null) {
      this.collapsedValue = savedState === 'true'
      // Update DOM immediately before any rendering
      this.element.setAttribute('data-sidebar-collapsed-value', this.collapsedValue.toString())
    }
    
    // Apply state immediately to prevent visual flash
    this.updateSidebar()
    
    // Remove body class used for initial state and show sidebar
    document.body.classList.remove('sidebar-will-be-collapsed')
    this.element.classList.add('sidebar-loaded')
  }

  toggle() {
    this.collapsedValue = !this.collapsedValue
    localStorage.setItem('sidebarCollapsed', this.collapsedValue.toString())
    this.updateSidebar()
  }

  collapsedValueChanged() {
    this.updateSidebar()
  }

  updateSidebar() {
    if (this.collapsedValue) {
      // Collapse sidebar
      this.sidebarTarget.classList.remove('w-64')
      this.sidebarTarget.classList.add('w-16')
      // Adjust content margin with !important classes
      this.contentTarget.classList.remove('sidebar-expanded')
      this.contentTarget.classList.add('sidebar-collapsed')
    } else {
      // Expand sidebar
      this.sidebarTarget.classList.remove('w-16')
      this.sidebarTarget.classList.add('w-64')
      // Adjust content margin with !important classes
      this.contentTarget.classList.remove('sidebar-collapsed')
      this.contentTarget.classList.add('sidebar-expanded')
    }
    
    // Update the data attribute for CSS (this controls button visibility)
    this.element.setAttribute('data-sidebar-collapsed-value', this.collapsedValue.toString())
  }
}